import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import * as moment from 'moment';
import * as _ from 'lodash';
import MaskedInput from 'react-text-mask';

import { deepEqual } from './../../utils';
import * as lifeEventsTypes from './../lifeEvents.types';

const initialState = () => {
  const now = moment();
  return {
    event: {
      startedAtYear: now.year(),
      startedAtDateHour: `${now.format('DD/MM')}`,
    },
  };
};

const AVAILABLE_YEARS = (currentYear => [
  currentYear + 1,
  currentYear,
  currentYear - 1,
  currentYear - 2,
])(moment().year());

class LifeEventForm extends Component {
  constructor(props) {
    super(props);
    this.state = initialState();
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onMetaHoursSizeChange = this.onMetaHoursSizeChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      !deepEqual(this.props.event, nextProps.event)
      || !deepEqual(this.props.lastEvent, nextProps.lastEvent)
    ) {
      this.resetState(nextProps.event, nextProps.lastEvent);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !deepEqual(this.props, nextProps)
      || !deepEqual(this.state, nextState);
  }

  onFieldChange(ev) {
    ev.preventDefault(true);
    this.setState({
      event: {
        ...this.state.event,
        [ev.target.id]: ev.target.value,
      },
    });
  }

  onSubmit(ev) {
    ev.preventDefault(true);
    this.save();
  }

  onCancel(ev) {
    ev.preventDefault(true);
    this.props.onCancel();
    this.resetState();
  }

  onMetaHoursSizeChange(ev) {
    ev.preventDefault(true);
    const days = Number(ev.target.value);
    const { eventType } = this.state.event;
    this.setState({
      event: {
        ...this.state.event,
        eventMetaHoursSize: days > 0 ? (days * 24) + (eventType === lifeEventsTypes.types.WEEKLY_REST ? 11 : 0) : 0,
      },
    });
  }

  get isValid() {
    const { lastEvent } = this.props;
    const { eventType, eventMetaHoursSize } = this.state.event;
    const { startedAtMoment } = this;
    return eventType
      && startedAtMoment.isValid()
      && startedAtMoment.valueOf() > ((lastEvent && lastEvent.startedAt) || 0)
      && eventType
      && (
        (eventType === lifeEventsTypes.types.WEEKLY_REST && eventMetaHoursSize)
        || (eventType !== lifeEventsTypes.types.WEEKLY_REST)
      );
  }

  get startedAtMoment() {
    const { startedAtYear, startedAtDateHour } = this.state.event;
    const fullMoment = moment(`${startedAtYear} ${startedAtDateHour}`, 'YYYY DD/MM HH:mm', true);
    return fullMoment.isValid() ? fullMoment : moment(`${startedAtYear} ${String(startedAtDateHour).slice(0, 5)}`, 'YYYY DD/MM', true);
  }

  resetState(event = this.state.event, lastEvent = this.props.lastEvent) {
    const newState = {};

    if (event.startedAt) {
      const now = moment(event.startedAt || undefined);
      newState.event = {
        ...event,
        startedAtYear: now.year(),
        startedAtDateHour: `${now.format('DD/MM')} 00:00`,
      };
      delete newState.event.startedAt;
    } else {
      Object.assign(newState, initialState());
    }

    if (!event.eventType && lastEvent) {
      if (lastEvent.eventType === lifeEventsTypes.types.WORK) {
        newState.event.eventType = lifeEventsTypes.types.WEEKLY_REST;
      } else {
        newState.event.eventType = lifeEventsTypes.types.WORK;
      }
    }

    this.setState(newState);
  }

  save() {
    if (!this.isValid) { return; }

    const event = {
      ...this.state.event,
      startedAt: this.startedAtMoment.valueOf(),
    };
    delete event.startedAtYear;
    delete event.startedAtDateHour;

    if (event.eventType !== lifeEventsTypes.types.WEEKLY_REST && event.eventType !== lifeEventsTypes.types.RECOUPED_WORK) { delete event.eventMetaHoursSize; }

    this.props.onSave(event);
    this.resetState();
  }

  render() {
    const { event } = this.state;
    const { startedAtMoment } = this;

    const metaHoursSize = ((hoursSize) => {
      if (hoursSize > 0) { return Math.floor(event.eventMetaHoursSize / 24); }
      if (event.eventMetaHoursSize === 0) { return 0; }
      return '';
    })(event.eventMetaHoursSize);

    return (
      <form style={{ display: 'flex', flexFlow: 'row wrap' }} onSubmit={this.onSubmit}>
        <div className="form-group inline">
          <label htmlFor="startedAtDateHour">Iniciando em</label>
          <select
            id="startedAtYear"
            className="form-control"
            value={event.startedAtYear}
            onChange={this.onFieldChange}
            style={{ width: '90px' }}
          >
            <option key="blank" value="" />
            {AVAILABLE_YEARS.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
          <MaskedInput
            id="startedAtDateHour"
            className="form-control"
            aria-describedby="formHelp"
            value={event.startedAtDateHour}
            onChange={this.onFieldChange}
            mask={[/[0-3]/, /\d/, '/', /[0-1]/, /\d/, ' ', /[0-2]/, /\d/, ':', /[0-5]/, /\d/]}
            style={{ width: '110px' }}
          />
          {startedAtMoment.isValid() && (
            <div className="form-group-description">
              <Moment calendar>{startedAtMoment.valueOf()}</Moment>
            </div>
          )}
        </div>

        <div className="form-group inline">
          <label htmlFor="eventType">Evento</label>
          <select
            id="eventType"
            className="form-control"
            value={event.eventType || ''}
            onChange={this.onFieldChange}
            style={{ width: '205px' }}
          >
            <option key="blank" value="" />
            {_.map(lifeEventsTypes.types, type => (
              <option key={type} value={type}>{lifeEventsTypes.humanizedNames[type]}</option>
            ))}
          </select>
          {(event.eventType === lifeEventsTypes.types.WEEKLY_REST || event.eventType === lifeEventsTypes.types.RECOUPED_WORK) && (
            <span style={{ marginLeft: '10px', marginRight: '5px' }}>Dias: </span>
          )}
          {(event.eventType === lifeEventsTypes.types.WEEKLY_REST || event.eventType === lifeEventsTypes.types.RECOUPED_WORK) && (
            <input
              id="metaHoursSize"
              className="form-control"
              value={metaHoursSize}
              onChange={this.onMetaHoursSizeChange}
              style={{ width: '45px' }}
            />
          )}
          {(event.eventType === lifeEventsTypes.types.WEEKLY_REST || event.eventType === lifeEventsTypes.types.RECOUPED_WORK) && (
            <div className="form-group-description">
              {!(event.eventMetaHoursSize >= 0) ? 'Digite o total de dias' : `${event.eventMetaHoursSize} Horas`}
              {(startedAtMoment.isValid() && event.eventMetaHoursSize > 0)
                && `, Até ${startedAtMoment.clone().add(event.eventMetaHoursSize, 'hours').calendar()}`}
            </div>
          )}
        </div>
        <div className="form-group form-group-button">
          <button type="submit" className="button button-primary button-right">Salvar</button>
          <button className="button button-right" onClick={this.onCancel}>Limpar</button>
        </div>
      </form>
    );
  }
}

LifeEventForm.propTypes = {
  event: PropTypes.object.isRequired,
  lastEvent: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

LifeEventForm.defaultProps = {
  lastEvent: undefined,
};

export default LifeEventForm;



// WEBPACK FOOTER //
// ./src/Driver/DriverLifeEventsPopup/LifeEventForm.js